export default class MenuDesktop {
	constructor() {
		this.navbar = document.querySelector(".header");
		this.main = document.querySelector("main");
		this.navPos = this.navbar.offsetTop;
		this.events();
	}

	events() {
		this.onscrollNav();

		window.addEventListener("scroll", () => {
			this.onscrollNav();
		});
	}

	onscrollNav() {
		let scrollPos = window.scrollY;

		if (scrollPos > this.navPos + 50) {
			this.navbar.classList.add("scrolled");
		} else {
			this.navbar.classList.remove("scrolled");
		}
	}

	focusElement(element) {
		let el = document.querySelector(element);
		if (el) el.focus();
	}
}
